(ns practitest.frontend.account-dashboard-settings.main
  (:require [practitest.frontend.components2.spinners :as spinners]
            [practitest.frontend.account-dashboard-settings.views :as views]
            [practitest.frontend.account-dashboard-settings.subs]
            [practitest.frontend.account-dashboard-settings.events]
            [practitest.frontend.common-old-fe.i18n :as i18n]
            [re-frame.core :as re-frame]
            [reagent.core                 :as reagent]
            [re-frame.db]))

(defn account-dashboard-settings-view []
  (if-let [_init-done? @(re-frame/subscribe [:account-dashboard-settings/init-complete?])]
    [views/main-panel]
    [:div.loader
      [spinners/mux-spinner {:size :modal}]]))

(defn ^:export legacy-init [config translation]
  (i18n/initialize (js->clj translation :keywordize-keys true))
  (re-frame/dispatch [:account-dashboard-settings/initialize (js->clj config :keywordize-keys true)])
  (re-frame/dispatch [:account-dashboard-settings/init-complete]))
